export const mapSubAccessControlToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfPermission: item?.permissions?.length,
  }));

  return result;
};

export const subAccessControlColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "route", label: "Email", align: "center" },
  { key: "numOfPermission", label: "Number Of Permission", align: "center" },
];
